export const PaymentProviderInfo = {
	HOTMART: {
		name: "Hotmart",
		key: "HOTMART",
		slug: "hotmart",
		logo: "https://scarf-public-assets.s3.us-east-1.amazonaws.com/integrations/hotmart.png",
	},
	EDUZZ: {
		name: "Eduzz",
		key: "EDUZZ",
		slug: "eduzz",
		logo: "https://scarf-public-assets.s3.us-east-1.amazonaws.com/integrations/eduzz.png",
	},
	GURU: {
		name: "Digital Manager Guru",
		key: "GURU",
		slug: "guru",
		logo: "https://scarf-public-assets.s3.us-east-1.amazonaws.com/integrations/guru.png",
	},
	TMB: {
		name: "TMB",
		key: "TMB",
		slug: "tmb",
		logo: "https://scarf-public-assets.s3.us-east-1.amazonaws.com/integrations/tmb.png",
	},
	HEROSPARK: {
		name: "HeroSpark",
		key: "HEROSPARK",
		slug: "herospark",
		logo: "https://scarf-public-assets.s3.us-east-1.amazonaws.com/integrations/herospark.png",
	},
	STRIPE: {
		name: "Stripe",
		key: "STRIPE",
		slug: "stripe",
		logo: "https://scarf-public-assets.s3.us-east-1.amazonaws.com/integrations/stripe.png",
	},
	HUBLA: {
		name: "Hubla",
		key: "HUBLA",
		slug: "hubla",
		logo: "https://scarf-public-assets.s3.us-east-1.amazonaws.com/integrations/hubla.jpeg",
	},
	KIWIFY: {
		name: "Kiwify",
		key: "KIWIFY",
		slug: "kiwify",
		logo: "https://scarf-public-assets.s3.us-east-1.amazonaws.com/integrations/kiwify.png",
	},
	TICTO: {
		name: "Ticto",
		key: "TICTO",
		slug: "ticto",
		logo: "https://scarf-public-assets.s3.us-east-1.amazonaws.com/integrations/ticto.jpeg",
	},
	KIRVANO: {
		name: "Kirvano",
		key: "KIRVANO",
		slug: "kirvano",
		logo: "https://scarf-public-assets.s3.us-east-1.amazonaws.com/integrations/kirvano.png",
	},
	GREENN: {
		name: "Greenn",
		key: "GREENN",
		slug: "greenn",
		logo: "https://scarf-public-assets.s3.us-east-1.amazonaws.com/integrations/greenn.png",
	},
} as const;

export function isKnownPaymentProvider(
	provider: string,
): provider is keyof typeof PaymentProviderInfo {
	return Object.hasOwn(PaymentProviderInfo, provider);
}
